export default {"src":"/_next/static/media/logo.23be122d.svg","height":69,"width":364,"blurWidth":0,"blurHeight":0};